import { createSlice } from '@reduxjs/toolkit'

import { fetchUpcomingInvoice } from './actions/fetch_upcoming_invoice'

const initialState = {
  invoice: null,
  error: null,
  loading: false
}

const upcomingInvoiceSlice = createSlice({
  name: 'upcomingInvoice',
  initialState,
  reducers: {
    resetInvoice: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUpcomingInvoice.pending, (state) => {
      state.loading = true
      state.invoice = null
    })
    builder.addCase(fetchUpcomingInvoice.fulfilled, (state, action) => {
      state.loading = false
      state.error = null
      state.invoice = action.payload
    })
    builder.addCase(fetchUpcomingInvoice.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })
  }
})

export const {
  reducer,
  actions: {
    resetInvoice
  }
} = upcomingInvoiceSlice
